import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '47157ec7e120c873fb7fabe94a2125613f93f0ca', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2112b5ffc0ca2022d3092d3c8ad143b0f9c6b8ac', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd72209737b9c4a88e9cac8662aa64439a858c872', d: "m15.285 11.75-3.146 3.145a.5.5 0 0 0 0 .707l.354.354a.5.5 0 0 0 .707 0l4.596-4.596a.5.5 0 0 0 .146-.357.5.5 0 0 0-.146-.357L13.2 6.05a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l3.14 3.139H4.56a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowRight$1);
            }
            break;
    } });
}

const CosmosIconArrowRight = CosmosIconArrowRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowRight, defineCustomElement };
